import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "45",
  height: "45",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M28.5696 40.995H16.3296C14.7996 40.995 13.5596 39.755 13.5596 38.225V8.82495H31.3396V38.225C31.3396 39.755 30.0996 40.995 28.5696 40.995ZM15.5596 10.835V38.2349C15.5596 38.6549 15.9096 39.005 16.3296 39.005H28.5696C28.9896 39.005 29.3396 38.6549 29.3396 38.2349V10.835H15.5596Z\" fill=\"currentColor\"></path><path d=\"M19.3696 9.505H17.3696V3.995H27.5297V9.415H25.5297V5.995H19.3696V9.505Z\" fill=\"currentColor\"></path><path d=\"M30.1883 30.2405L14.3232 34.4736L14.8388 36.406L30.7039 32.1729L30.1883 30.2405Z\" fill=\"currentColor\"></path><path d=\"M30.1883 22.3106L14.3232 26.5437L14.8388 28.4761L30.7039 24.243L30.1883 22.3106Z\" fill=\"currentColor\"></path><path d=\"M30.1883 14.3807L14.3232 18.6138L14.8388 20.5462L30.7039 16.3131L30.1883 14.3807Z\" fill=\"currentColor\"></path>", 5)
  ])))
}
export default { render: render }